import { Typography } from '@mui/joy';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { ISubmitAction } from 'core/types';
import { IQuoteReleaseVersionForm } from 'quotes/types';

interface IProps {
  getSubmitActions: () => ISubmitAction[];
  isOpen?: boolean;
  onClose?: (reset?: UseFormReset<IQuoteReleaseVersionForm>) => void;
}

const QuoteVersionReleaseFormView = ({ getSubmitActions, isOpen = false, onClose }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form
      title={t('titleReleaseVersion')}
      isOpen={isOpen}
      onClose={onClose}
      cancelBtnLabel={t('buttonLabelCancel')}
      getSubmitActions={getSubmitActions}
    >
      <Typography>{t('messageReleaseDraftVerison')}</Typography>

      <FormField
        name="note"
        type={InputType.TEXT_EDITOR}
        inputProps={{
          label: t('labelMessage'),
        }}
      />

      <FormField
        name="attachPdf"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('labelAttachPdf'),
        }}
      />

      <FormField
        name="attachXls"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('labelAttachXls'),
        }}
      />
    </Form>
  );
};

export default QuoteVersionReleaseFormView;
